import Structure from "./Structure";
import ContextMenu from './ContextMenu';
import { useState } from 'react';
import ExpandedIcon from '@material-ui/icons/ArrowDropDown';

const structures = {
  1:[[["A"]]],
  2:[[["A","B"]],[["A"],["B"]]],
  3:[[["A","B","C"]],[["A"],["B"],["C"]]],
  4:[
    [["A","B","C","D"]],
    [["A"],["B"],["C"],["D"]],
    [["A","B"],["C","D"]]
    ],
  5:[
    [["A","B","C","D","E"]],
    [["A"],["B"],["C"],["D"],["E"]],
    ],
  6:[
    [["A","B","C","D","E","F"]]
    ],
}




const items = Object.keys(structures).map(numBoxes => {

  let structs = structures[numBoxes]
  let submenu = structs.map(ss => ({hoverable:true, action:ss, title:(
    <Structure size={8} structure={ss}/>
  )}))

  return ({
    hoverable:true,
    ignore:(submenu.length > 1),
    action:(submenu.length === 1 ? structs[0] : (numBoxes+"")),
    title:""+numBoxes,
    submenu,
  })
})


export default function NewStructurePicker({value,onChange}){

  

  const [open,setOpen] = useState(false);
  const [openPath, setOpenPath] = useState([]);

  return (
    <div>

      <div class="sg-row fair-margin-right">
        <div style={{padding:10, fontSize:18, textAlign:'start'}}>Layout:</div>

    <div class="flex-expand"/>
      <div class="sg-row v-center">

        

        <div onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(true)
        }} class="rel sg-row v-center border small-padding round-corners clickable hoverable">

          <input spinner={"n-channel-slots"} style={{width:60}}
            value={value}
          type="number"/>


          {true && <Structure 
            interactive={false}  
            structure={value}
            size={10}
          />}
          <ExpandedIcon style={{fontSize:18}}/>

          {open && <div class="absolute-cover"
            style={{
              transform:'translate(calc(100% - 5px),calc(50% + 5px))'
            }} >

            {open && <ContextMenu {...{

              onEvent:({action}) => {
                if( action in structures ){
                  return;
                }
                onChange(action);
              },
              items,
              treeLevel:0,
              onClose:() => setOpen(false),
              openPath,
              setOpenPath,
              closeOnOutsideClick:true,

            }}/>}
          </div>}

        </div>

      </div>
    </div>
    </div>
  );

}
